// import React from 'react';

// const Toast = ({ toasts }) => {
//   const icons = { success: '✅', error: '❌', info: 'ℹ️' };

//   return (
//     <div className="toast-container">
//       {toasts.map(toast => (
//         <div key={toast.id} className={`toast ${toast.type}`}>
//           <span>{icons[toast.type]}</span>
//           <span>{toast.message}</span>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default Toast;



// src/components/Common/Toast.jsx
import React from 'react';
import { CheckCircle2, XCircle, Info } from 'lucide-react';

const Toast = ({ toasts }) => {
  const icons = { success: CheckCircle2, error: XCircle, info: Info };

  return (
    <div className="toast-container">
      {toasts.map(toast => {
        const IconComponent = icons[toast.type];
        return (
          <div key={toast.id} className={`toast ${toast.type}`}>
            <span>{IconComponent && <IconComponent size={20} />}</span>
            <span>{toast.message}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Toast;